module.exports = __webpack_public_path__ + "img/Thevillain.a00fec3f.png";